import React, { useState, useEffect } from "react";
import useRouting from "../hooks/useRouting";
import { trackEvent } from "../utils/trackEvent";
import Header from "./Header";
import "./PersonalLoanMessage.css";
import MedicalLoan from "../assets/images/MedicalLoan.svg";
import EmergencyFund from "../assets/images/EmergencyFund.svg";
import environment from "../environment";

const PersonalLoanMessage = () => {
  const { navigateWithContext } = useRouting();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => { trackEvent("loan_personal_loan_message_viewed"); }, []);


  

  const handleBack = () => {
    navigateWithContext("loan-type");
  };

  const handleMedicalLoan = () => {
    trackEvent("loan_personal_loan_message_cta_clicked");
    localStorage.setItem("forceMedicalLoan", "true");
    navigateWithContext("loan-type");
  };

  // const handleExit = () => {
  //   navigateWithContext("");
  // };
  const handleExit = async () => {
    setIsLoading(true);

    // If user logged in via OTP (no bypass key), just clear session and go back to login
    const isOtpLogin = localStorage.getItem("otpVerified") === "true";
    if (isOtpLogin) {
      localStorage.removeItem("token");
      localStorage.removeItem("application_id");
      localStorage.removeItem("anchor");
      localStorage.removeItem("otpVerified");
      localStorage.removeItem("phoneNumber");
      setIsLoading(false);
      navigateWithContext("");
      return;
    }

    // eslint-disable-next-line no-undef
   // const baseUrl = process.env.REACT_APP_BASE_URL || "https://sandbox.ayushpay.com";
    // eslint-disable-next-line no-undef
   // const feBaseUrl = process.env.REACT_APP_FE_BASE_URL || "https://eci-sandbox.ayushpay.com";
    try {
      const authToken = localStorage.getItem("token");
      const applicationId = localStorage.getItem("application_id");

      if (!authToken || !applicationId) {
        throw new Error("Missing auth token or application ID");
      }

      const apiUrl = `${environment.REACT_APP_BASE_URL}/eci/apis/v4/applications/${applicationId}/sso/apply_loan/`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ authToken, applicationId }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data?.message || "Exit API failed");

      const redirectKey = data?.msg?.access_key;
      const anchor = localStorage.getItem("anchor") || "ayushpay";
      if (redirectKey) {
        // redirect to ECI subscription build route
        const redirectUrl = `${environment.REACT_APP_FE_BASE_URL}/${anchor}/subscription?key=${redirectKey}`;
        window.parent.location.href = redirectUrl;
      } else {
        throw new Error("Invalid redirect key");
      }
    } catch (error) {
      console.error("EXIT ERROR:", error);
    } finally {
      setIsLoading(false);
    }
  };



  // const endpoint = `${environment.apiurlv3_webapi}applications/${applicationId}/view/data/?allowed=personal`;
  //     const response = await axios.get(endpoint, { headers: getHeaders() });
  //     if (response.status === 200) {
  //       const data = response.data;
  //       setApplicationData(data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching application data:", error);
  //   }



  return (
    <div className="loan-container">
      <Header showBackButton={false} onBackClick={handleBack} />

      <div className="main-content">
        <div className="hero-section">
          <div className="hero-text">
            <h1 className="hero-title">
              Hi there!
              <br />
              Currently we offer
              <br />
              only lowest cost
              <br />
              medical loans
            </h1>
          </div>
          <div className="hero-icon">
          <img src={MedicalLoan} alt="MedicalLoan" />

          </div>
        </div>
        <div className="hero-section hero-subtitle-message">
          <div className="hero-text">
            <h1 className="hero-subtitle">
              Please get back to us if you need a medical loan in the future
            </h1>
          </div>
        </div>

        <div className="illustration-section">
          <img src={EmergencyFund} alt="EmergencyFund" />
        </div>
      </div>

      <div className="fixed-button-container">
        <button
          className="continue-button medical-loan-button"
          onClick={handleMedicalLoan}
        >
          MEDICAL LOAN
        </button>
        <button 
          className="secondary-button exit-button" 
          onClick={handleExit}
          disabled={isLoading}
        >
          {isLoading ? "LOADING..." : "EXIT"}
        </button>
      </div>

    </div>
  );
};

export default PersonalLoanMessage;
